

const state = {
    tabs: [
        { id: 'details', name: 'Details', status: true, link: null },
        { id: 'credit', name: 'Credit', status: false, link: null},
        { id: 'bids', name: 'Bids', status: false, link: null  },
        { id: 'logs', name: 'Logs', status: false, link: null },
        { id: 'garage', name: 'Garage', status: false, link: null },
        { id: 'balance', name: 'Balance', status: false, link: null },
        { id: 'client-balance', name: 'Client Balance', status: false, link: null },
        { id: 'multiProforma', name: 'MultiProforma', status: false, link: null },
        { id: 'messages', name: 'Messages', status: false, link: 'UserMessages' },
        { id: 'invoices', name: 'Invoice details', status: false, link: null },
        { id: 'consignees', name: 'Consignees', status: false, link: null },
        { id: 'other', name: 'Other', status: false, link: 'UserOther'}
    ]
}

const getters = {
    getUserActiveTab: (state) => {
        return state.tabs.filter(function (tabs) {
            return tabs.status === true;
        });
    },
    getAllUserTabs: (state) => {
        return state.tabs
    }
}

const mutations = {
    updateUserActiveTab: (state, tabId) => {
        state.tabs.forEach(function (tab)  {
            tab.id === tabId ? tab.status = true : tab.status = false
        })
   }
}

const actions = {
    setActiveUserTab: ({ commit }, tabId) => {
        commit('updateUserActiveTab', tabId)
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/userSideBar.js